<img [ngStyle]="{'height':Height, 'width':Width}" [src]="src">